var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Flex',{staticClass:"login-page"},[_c('div',[_c('Spacer',{staticClass:"typo--2 t-center",attrs:{"x":"m","top":{
        default: 'l',
        s: 'xl'
      },"bottom":"m"}},[_vm._v(" "+_vm._s(_vm.$labels.recover)+" ")]),_c('Wrapper',{attrs:{"size":"m","boxed":""}},[_c('Form',{staticClass:"form--single",attrs:{"id":"recovery-password"}})],1)],1),_c('LoginRightPanel')],1)}
var staticRenderFns = []

export { render, staticRenderFns }